export const singlelogin = {
  headerTitle: 'Mehrfachanmeldung',
  route: 'singlelogin',
  pageTitle: 'Mehrfachanmeldung',
  related: [
    { route: 'benutzerverwaltung/lehrerinnen', menuTitle: 'Lehrer*innen verwalten' },
    { route: 'benutzerverwaltung/schuelerinnen', menuTitle: 'Schüler*innen verwalten' }
  ],
  cards: [
    {
      route: 'lehrerinnen',
      icon: 'fa-users-slash',
      endpoint: '/api/singlelogin/teachers',
      preHooks: {
        list: 'singlelogin_list_preHook'
      },
      tag: 'paedml-card-singlelogin',
      category: 'Mehrfachanmeldung',
      menuTitle: 'Lehrer*innen',
      pageTitle: 'paed.ML - Mehrfachanmeldung Lehrer*innen',
      name: 'singleloginlul',
      contentTitle: 'Lehrer*innen',
      prefix: 'singleloginlul',
      suffix: undefined,
      custom: {
        variant: 'teacher'
      },
      table: {
        columns: [
          { title: 'Benutzername', name: 'userName', col: 0 },
          { title: 'Name', name: 'displayName', col: 1 },
          { title: 'Basis-Schule', name: 'mainSchoolType', col: 2 },
          { title: 'Schule(n)', name: 'schoolTypes', separator: ', ', col: 3, filter: 'Schule', filterType: 'regex' },
          { title: 'Mehrfachanmeldung verhindert', name: 'isSingleLoginEnabled', col: 4, filter: 'JaNein', filtertitle: 'Mehrfachanmeldung verhindert' },
          { title: 'Angemeldet', name: 'isLoggedIn', col: 5 },
          { title: 'angemeldetPc', name: 'loggedOnDevices', col: 6, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Anmeldung freigegeben', name: 'allowLogin', col: 7 },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
        }
      }
    },

    {
      route: 'schuelerinnen',
      icon: 'fa-users-slash',
      endpoint: '/api/singlelogin/students',
      preHooks: {
        list: 'singlelogin_list_preHook'
      },
      tag: 'paedml-card-singlelogin',
      category: 'Mehrfachanmeldung',
      menuTitle: 'Schüler*innen',
      pageTitle: 'paed.ML - Mehrfachanmeldung Schüler*innen',
      name: 'singleloginsus',
      contentTitle: 'Schüler*innen',
      prefix: 'singleloginsus',
      suffix: undefined,
      custom: {
        variant: 'student'
      },
      table: {
        columns: [
          { title: 'Benutzername', name: 'userName', col: 0 },
          { title: 'Name', name: 'displayName', col: 1 },
          { title: 'Schule', name: 'schoolType', col: 2, filter: 'Schule', filterType: 'regex' },
          { title: 'Klasse', name: 'schoolClass', col: 3, filter: 'Klasse', dynamicfilter: 'klassen', filterType: 'regex' },
          { title: 'Schuljahr', name: 'schoolYear', col: 4, searchable: false },
          { title: 'Mehrfachanmeldung verhindert', name: 'isSingleLoginEnabled', col: 5, filter: 'JaNein', filtertitle: 'Mehrfachanmeldung verhindert' },
          { title: 'Angemeldet', name: 'isLoggedIn', col: 6 },
          { title: 'angemeldetPc', name: 'loggedOnDevices', col: 7, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Anmeldung freigegeben', name: 'allowLogin', col: 8 },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
        }
      }
    },

    {
      route: 'klassenarbeiten',
      icon: 'fa-users-slash',
      endpoint: '/api/singlelogin/exammembers',
      preHooks: {
        list: 'singlelogin_list_preHook'
      },
      tag: 'paedml-card-singlelogin',
      category: 'Mehrfachanmeldung',
      menuTitle: 'Klassenarbeiten',
      pageTitle: 'paed.ML - Mehrfachanmeldung Klassenarbeiten',
      name: 'singleloginexam',
      contentTitle: 'Klassenarbeiten',
      prefix: 'singleloginexam',
      suffix: undefined,
      custom: {
        variant: 'exammember'
      },
      table: {
        columns: [
          { title: 'Benutzername', name: 'userName', col: 0 },
          { title: 'Name', name: 'displayName', col: 1 },
          { title: 'Schule', name: 'schoolType', col: 2, filter: 'Schule', filterType: 'regex' },
          { title: 'Klasse', name: 'schoolClass', col: 3, filter: 'Klasse', dynamicfilter: 'klassen', filterType: 'regex' },
          { title: 'Schuljahr', name: 'schoolYear', col: 4, searchable: false },
          { title: 'Klassenarbeit', name: 'examTitle', col: 5 },
          { title: 'Mehrfachanmeldung verhindert', name: 'isSingleLoginEnabled', col: 6, filter: 'JaNein', filtertitle: 'Mehrfachanmeldung verhindert' },
          { title: 'Angemeldet', name: 'isLoggedIn', col: 7 },
          { title: 'angemeldetPc', name: 'loggedOnDevices', col: 8, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Anmeldung freigegeben', name: 'allowLogin', col: 9 },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
        }
      }
    },
  ]
}
